module.exports = __webpack_public_path__ + "img/folders.f5eb93fa.svg";